import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const CSP_NAVBAR_EVENT_NAMES = {
  TEST_MODE_TOGGLE: 'click_turn_test_mode',
};

export const trackTestModeToggle = (isOn, irpVersion) => {
  const testModeStatus = isOn ? 'on' : 'off';

  gspx.trackEvent({
    name: CSP_NAVBAR_EVENT_NAMES.TEST_MODE_TOGGLE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `Click turn ${testModeStatus} test mode in CSP`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};
